import { isAxiosError } from 'axios';

import { getApiErrorMessage } from '~/apis/cn02FormApi';
import { publicApiClient } from '~/lib/api/client';

type VerifyTurnstileResponse = {
  success: boolean;
};

export async function verifyTurnstile(turnstileToken: string): Promise<void> {
  const token = turnstileToken?.trim();
  if (!token) {
    throw new Error('Missing Turnstile token.');
  }

  const res = await publicApiClient.post<VerifyTurnstileResponse>(
    '/auth/turnstile/verify',
    { turnstileToken: token },
    { headers: { 'Content-Type': 'application/json' } }
  );

  if (!res.data?.success) {
    throw new Error('Turnstile verification failed.');
  }
}

export function getTurnstileSubmitErrorMessage(
  error: unknown,
  fallback = 'Submission failed. Please try again.'
): string {
  if (isAxiosError(error)) {
    const status = error.response?.status;
    if (status === 400) {
      return 'Security verification is required. Please refresh the page and try again.';
    }
    if (status === 403) {
      return 'Security verification failed. Please try submitting again.';
    }
    if (status === 502) {
      return 'Security verification is temporarily unavailable. Please try again in a moment.';
    }
    if (status === 500) {
      return 'Service temporarily unavailable. Please try again later.';
    }
  }

  return getApiErrorMessage(error, fallback);
}
